// extracted by mini-css-extract-plugin
export default {"cls1":"AboutTheAuthorsSSR-cls1__zG","cls2":"AboutTheAuthorsSSR-cls2_vUs AboutTheAuthorsSSR-cls1__zG"};